import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { Subscription } from '@apollo/client/node_modules/zen-observable-ts';

import { useAuth } from '../../../context/Auth';
import {
  LIST_CHAT_NOTIFICATIONS,
  ON_CHAT_MESSAGE,
} from '../../../http/apollo-queries';
import { clientPromise } from '../../../http/apollo.config';
import { useChat } from '../../../context/Chat';
import NotificationCircle from '../../NotificationCircle/NotificationCircle';
import { Icon } from '../../UI';
import { MessageTypes, NotificationMessage } from './types';
import { useSidebar } from '../../../context/Sidebar';
import Chat from './Chat';

const normalizeNotifications = (data: any[]) =>
  data
    .filter(({ seen }) => !seen)
    .map(({ chatMessage, ...rest }) => ({
      ...rest,
      ...chatMessage,
      notificationId: rest.id,
      type: MessageTypes.MENTION,
    }));

const ChatButton = () => {
  const { chatId, setChatId, setNotificationMessage } = useChat();

  const { isOpen, setIsOpen, setContent, setTitle, title } = useSidebar();

  const { data } = useQuery(LIST_CHAT_NOTIFICATIONS);

  const { user } = useAuth();

  const [chatNotifications, setChatNotifications] = useState<
    NotificationMessage[]
  >([]);

  useEffect(() => {
    if (data?.listChatNotifications?.items) {
      setChatNotifications(
        normalizeNotifications(data.listChatNotifications.items)
      );
    }
  }, [data]);

  const handleClick = () => {
    if (chatNotifications.length) {
      const latestNotification = chatNotifications[0];

      setChatId(latestNotification.chatRoomId);
      setNotificationMessage(latestNotification);
      setChatNotifications((prevState) =>
        prevState.filter(({ id }) => id !== latestNotification.id)
      );
    }

    if (!isOpen || title !== 'CHAT') {
      setIsOpen(true);
      setTitle('CHAT');
      setContent(<Chat />);
    } else {
      setIsOpen(false);
      setTitle('');
    }
  };

  useEffect(() => {
    const audio = new Audio('notification.mp3');

    let subscription: any;
    clientPromise.then((client) => {
      subscription = client
        .subscribe({
          query: ON_CHAT_MESSAGE,
        })
        .subscribe({
          next({ data: response }) {
            const data = response?.onChatMessage;
            if (data) {
              if (
                data.type === MessageTypes.MENTION &&
                user &&
                data.targetUserIds.indexOf(user.id) !== -1
              ) {
                audio.play();
                setChatNotifications((items: any) => [...items, data]);
              } else if (chatId === data.chatRoomId) {
                setNotificationMessage(data);
              }
            }
          },
        });
    });

    return () => {
      if (subscription) {
        (subscription as Subscription).unsubscribe();
      }
    };
  }, [user, chatId]);

  return (
    <div className="relative cursor-pointer">
      <Icon
        className="ml-auto w-4 h-4 text-lg cursor-pointer"
        color="black"
        svgName={'chat'}
        onClick={handleClick}
      />
      <NotificationCircle
        count={chatNotifications.length}
        classes="absolute -top-3 -right-2"
      />
    </div>
  );
};

export default ChatButton;
